import { api } from "@/lib/api";

// Feature flags, read through the Go API (ADR-0007 slice F).
export namespace FlagApi {
  /**
   * One flag record, or undefined when no such flag exists.
   *
   * The distinction matters to the flag cache, which treats "no such flag" as
   * a definitive OFF and stops retrying, but treats a failure as transient and
   * keeps the last known value. Through the collection API it could not tell
   * them apart: PocketBase answers a missing record, a rule-blocked read and
   * an expired token all with 404, so the cache carried a
   * `pb.authStore.isValid` guard to guess which it was. Here absence is a 200
   * with a null body and a failure throws, so the guess is gone.
   */
  export async function fetchFlag<TFlag>(flagId: string, signal?: AbortSignal): Promise<TFlag | undefined> {
    if (!flagId) return undefined;
    const res = await api<{ flag: TFlag | null }>("/app/feature-flags/one", {
      method: "GET",
      query: { flag_id: flagId },
      signal,
    });
    return res.flag ?? undefined;
  }
}
